export const classes = {
  grid: 'w-full flex flex-wrap gap-4 pb-4',
  auroraGrid: 'grid w-full items-start gap-[14px]',
  auroraFolderGrid:
    'mb-[14px] grid-cols-[repeat(auto-fill,minmax(220px,260px))]',
  auroraFileGrid: 'pb-12 grid-cols-[repeat(auto-fill,minmax(180px,200px))]',
};
